<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">

</head>

<body>
  <div class="container white_bg body_min_height">
    <div class="PageTitle">
      <h3 id="title" style="text-align: center;"><b>Enterprise Factory Systems</b></h3>
    </div>

    <!-- test buttons -->
    <!-- <div class="row">
      <div class="col-12">
          <button
              class="mdc-button mdc-button--raised mx-lg-3 mdc-button-secondary">
              <span
                  class="mdc-button__ripple"></span>Secondary
          </button>
          <button
              class="mdc-button mdc-button--raised mx-lg-3 mdc-button-secondary active">
              <span
                  class="mdc-button__ripple"></span>Secondary
              Hovered/Active
          </button>
          <button
              class="mdc-button mdc-button--raised mx-lg-3 mdc-button-primary">
              <span
                  class="mdc-button__ripple"></span>Primary
          </button>
          <button
              class="mdc-button mdc-button--raised mx-lg-3 mdc-button-primary active">
              <span
                  class="mdc-button__ripple"></span>Primary
              Hovered/Active
          </button>
          <button
              class="mdc-button mdc-button--raised mx-lg-3 mdc-button-secondary"
              disabled>
              <span
                  class="mdc-button__ripple"></span>Disabled
          </button>
      </div>
  </div> -->


    <div class="links-grid-container">
      <a (click)="navigateTo('setup'); logNavigation('Setup')"
        class="sm-link sm-link_padding-all sm-link1 styled-links">
        <h4 class="sm-link__label"><b>Setup</b></h4>
      </a>

      <!-- permissionHandlingService.csRead || permissionHandlingService.phRead -->
      <a *ngIf="permissionHandlingService.csRead || permissionHandlingService.phRead"
        (click)="navigateTo('nationalSetup'); logNavigation('nationalSetup')"
        class="sm-link sm-link_padding-all sm-link1 styled-links">
        <h4 class="sm-link__label"><b>National Setup</b></h4>
      </a>

      <a *ngIf="permissionHandlingService.dashboardRead"
        (click)="navigateTo('clientSummary'); logNavigation('National Dashboard')"
        class="sm-link sm-link_padding-all sm-link1 styled-links">
        <h4 class="sm-link__label"><b>National Dashboard</b></h4>
      </a>

      <a *ngIf="permissionHandlingService.raWrite" (click)="navigateTo('roleAdmin'); logNavigation('roleAdmin')"
        class="sm-link sm-link_padding-all sm-link1 styled-links">
        <h4 class="sm-link__label"><b>Role Admin</b></h4>
      </a>

      <a *ngIf="permissionHandlingService.raWrite"
        (click)="navigateTo('singleUserSetupICC'); logNavigation('singleUserSetupICC')"
        class="sm-link sm-link_padding-all sm-link1 styled-links">
        <h4 class="sm-link__label"><b>Single User Setup ICC</b></h4>
      </a>

      <!-- need to change permissions when possible -->
      <a *ngIf="permissionHandlingService.slaWrite"
        (click)="navigateTo('corpSlaExportReport'); logNavigation('corpSlaExportReport')"
        class="sm-link sm-link_padding-all sm-link1 styled-links">
        <h4 class="sm-link__label"><b>Corp SLA Export Report</b></h4>
      </a>

      <!-- need to change permissions when possible -->
      <a *ngIf="this.permissionHandlingService.permissionsMap.get('EFS- A&R READ')"
        (click)="navigateTo('archivalAndRetrieval'); logNavigation('Archival and Retrieval')"
        class="sm-link sm-link_padding-all sm-link1 styled-links">
        <h4 class="sm-link__label"><b>Archival and Retrieval</b></h4>
      </a>

      <!-- <a *ngIf="this.permissionHandlingService.permissionsMap.get('EFS- A&R READ')"
        (click)="navigateTo('mk-bill-of-material'); logNavigation('MK Bill of Material')"
        class="sm-link sm-link_padding-all sm-link1 styled-links">
        <h4 class="sm-link__label"><b>MK Bill of Material</b></h4>
      </a> -->
    </div>


  </div>
</body>